import * as React from "react";
import Component from "../../AbstractComponent";
import AgreementSummary from "./AgreementSummary";
import AgreementDetailsReadonly from "./AgreementDetailsReadonly";
import AgreementDetailsEditable from "./AgreementDetailsEditable";
import {
	Card
} from '@material-ui/core';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';

export default class AgreementCard extends Component {
	public state = {
		isSummaryView: true
	};

  constructor(public props) {
    super(props);

		let isSummaryView = true;

		if (this.props.dialogPresentation) {
			isSummaryView = false;
		}

		if (typeof this.props.isSummaryView !== "undefined") {
			isSummaryView = this.props.isSummaryView;
		}

		const isReadonly = this.props.agencyFee?.isReadonly ||
											 this.props.isReadonly;

		if ((this.props.mainCardPresentation && isReadonly) || this.props.openedByDefault) {
			isSummaryView = false;
		}

		this.state.isSummaryView = isSummaryView;
	}

	public changeView = (): void => {
		if (typeof this.props.agencyFeeIdForDetailsPresentation !== "undefined") {
			if (this.props.agencyFeeIdForDetailsPresentation === this.props.agencyFee?.id) {
				this.props.changeAgreementIdForDetailsPresentation.call(this, null);
			} else {
				this.props.changeAgreementIdForDetailsPresentation.call(this, this.props.agencyFee?.id);
			} 
		} else {
			this.setState({
				isSummaryView: !this.state.isSummaryView
			})
		}
	}
	
  public render() {
		const isReadonly = this.props.agencyFee?.isReadonly ||
											 this.props.isReadonly;
		const isSummaryView = typeof this.props.agencyFeeIdForDetailsPresentation !== "undefined" ?
														this.props.agencyFeeIdForDetailsPresentation !== this.props.agencyFee?.id :
														this.state.isSummaryView;

    return (
			<Card 
				className="card no-padding" 
				style={{position: "relative"}}
				onClick={isSummaryView ? this.changeView : null}
			>
				<div 
					className="right-buttons" 
					style={{
						position: "absolute",
						right: 0,
						width: "100%",
						height: "60px",
						display: "flex",
						justifyContent: "flex-end",
						paddingRight: "7px"
					}} 
					onClick={!isSummaryView ? this.changeView : null}
				>
					{
						isSummaryView ? 
							<ExpandMore style={{cursor: "pointer", marginTop: "6px"}} onClick={this.changeView}/> : 
							<ExpandLess style={{cursor: "pointer", marginTop: "6px"}} onClick={this.changeView}/>
					}
				</div>

				<div className="main-inner-wrapper" style={{padding: "10px 40px 10px 10px", marginBottom: "10px"}}>
					{
						isSummaryView && <AgreementSummary {...this.props}/>
					}

					{
						!isSummaryView && (isReadonly || !this.props.mainCardPresentation) && <AgreementDetailsReadonly {...this.props}/>
					}	

					{
						!isSummaryView && !isReadonly && this.props.mainCardPresentation && <AgreementDetailsEditable {...this.props}/>
					}	
				</div>
				<div style={{height: "1px"}}></div>
			</Card>
    );
  }
}
